import { ChangeDetectorRef, EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subject } from 'rxjs';
import { UntypedFormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { CookieService } from '@gorniv/ngx-universal';
import { Constant } from './data';
import { MessageService } from './message.service';
import * as _ from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';
import { db } from './dexiedb/livetvdb.service';
import { Moviesdb } from './dexiedb/moviedb.service';
import { Seriesdb } from './dexiedb/seriesdb.service';
import { PlaylistlogoutModalComponent } from 'src/app/Shared/modal/playlistlogout-modal/playlistlogout-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

declare var $: any;

const TOAST_CONFIG: any = {
    timeOut: 4000,
    positionClass: 'toast-bottom-right',
    toastClass: 'ngx-toastr animated pulse fadeInUp',
    progressBar: true,
    progressAnimation: 'decreasing',
    tapToDismiss: true,
    closeButton: true
};
@Injectable({
    providedIn: 'root'
})
export class UtilService {
    public sortingType = new EventEmitter();
    bsModalRef: BsModalRef;

    isSort: boolean = true;
    ipcRenderer: any;

    public static API_TIMEOUT = 90000;
    LOGOUT_MSG = 'There was no activity on the site for a period of time, the session was ended for security reasons. Sign in to return to your account.';

    public loginObservable = new Subject<any>();
    login$ = this.loginObservable.asObservable();


    public filterResetObservable = new Subject<any>();
    filterReset$ = this.filterResetObservable.asObservable();

    public static BSCONFIG = { containerClass: 'theme-dark-blue' };

    accessedTab: any = null;
    remove_from_fav = ['COMMON.REMOVE_FROM_FAVOURITE'];
    private logoutSubject = new Subject<void>();
    logout$ = this.logoutSubject.asObservable();
    private secretKey = environment.encryptionKey;

    code:any = ''
    // SZHTDO A306FB MT5WD3 L0K5OW
    constructor(
        private toastr: ToastrService,
        private appCookie: CookieService,
        private router: Router,
        private http: HttpClient,
        private cookieService: CookieService,
        private messageService: MessageService,
        private spinner: NgxSpinnerService,
        private translate: TranslateService,
        private modalService: BsModalService,

        
    )
    {
        if (window && window.require) {
            try {
              this.ipcRenderer = window.require('electron').ipcRenderer;
            } catch (e) {
              console.error('Could not load Electron IPC:', e);
            }
          }
    }

    isLoginWithCode(): [boolean, string] {
        if (this.code) {
            return [true, this.code]; // Return true and code if not empty
        } else {
            return [false, '']; // Return false and empty string if code is empty
        }
    }

    addSorting(type: any) {
        this.sortingType.next(type);
    }

    getSorting() {
        return this.sortingType;
    }

    commonSort(isSort: boolean, property: string, array) {
        let direction = isSort ? 1 : -1;
        array.sort((a, b) => {
            if (a[property] < b[property]) {
                return -1 * direction;
            } else if (a[property] > b[property]) {
                return 1 * direction;
            } else {
                return 0;
            }
        });
    }
    // sortCommonCategorywise(property: string, sortType: any, array: any, callback: any) {
    //     callback(_.orderBy(array, [property], [sortType]));
    // }
    sortCommonCategorywise(property: string, sortType: 'asc' | 'desc', array: any[], callback: (result: any[]) => void) {
  const sorted = _.orderBy(
    array,
    [(item) => (item[property] || '').toLowerCase()],
    [sortType]
  );
  callback(sorted);
}


    tabWiseSearchSorting(isSort, searchType, categoriesArray, callback) {
        if (searchType == 'category_name') {
            callback(_.orderBy(categoriesArray, [searchType], [isSort]));
        } else if (searchType == 'new_realease') {
            callback(_.orderBy(categoriesArray, { category_name: 'NEW RELEASES' }, ['desc']));
        } else if (searchType == 'name') {
            callback(_.orderBy(categoriesArray, [searchType], [isSort]));
        } else if (searchType == 'only_series') {
            if (isSort == 'desc') {
                callback(_.sortBy(categoriesArray, (season) => {
                    return season.info.name;
                }));
            } else {
                callback(categoriesArray.reverse())
            }
        }
    }

    sortFromHeader(arrayName: any, property) {
        this.isSort = !this.isSort;
        let direction = this.isSort ? 1 : -1;
        arrayName.sort(function (a, b) {
            if (a[property] < b[property]) {
                return -1 * direction;
            }
            else if (a[property] > b[property]) {
                return 1 * direction;
            }
            else {
                return 0;
            }
        });
    }

    showErrorInfo(title: string = '', message: string = '') {
        this.toastr.info(message, title, TOAST_CONFIG);
    }

    showErrorToast(title: string = 'Something went wrong.', message: string = 'Please, try again later.') {
        this.toastr.error(message, title, TOAST_CONFIG);
    }
    showErrorSuccess(title: string = 'Success!', message: string = '') {
        this.toastr.success(message, title, TOAST_CONFIG);
    }
    showSuccess(title: string = 'Success', message: string = '') {
        this.toastr.success(message, title, TOAST_CONFIG)
    }

    showSpinner() {
        this.spinner.show()
    }
    hideSpinner() {
        this.spinner.hide()
    }

    markFormGroupDirty(formGroup: UntypedFormGroup) {
        Object.keys(formGroup.controls).forEach(key => {
            formGroup.get(key)?.markAsDirty();
        });
    }


    public showErrorCall(err: any, show: number = 0) {
        try {
            if ((err.status === 401 || err.status === 403) && (this.router.url.indexOf('/auth/') < 0 || this.router.url.indexOf('/final-step') > 0)) {
                this.showErrorInfo('', this.LOGOUT_MSG);
                this.logout();
            } else if (err.error) {
                try {
                    const errBody: any = err.error;
                    const errStr = errBody.message || errBody.title;
                    // Object.keys(errBody).map(val => errStr += errBody[val]);
                    if (err.status === 404) {
                        if (errBody.details) {
                            this.showErrorToast('', errBody.details);
                        }
                        // this.showErrorToast('', errStr);
                    } else if (err.status === 406 && errBody.message) {
                        // if (errBody.message == 'Sorry you have to login first') {
                        //   this.logout()
                        // }
                        if (show === 0) {
                            this.showErrorToast('', errBody.message);
                        }
                    } else {
                        if (show === 0) {
                            this.showErrorToast('', errStr);
                        }
                    }
                    // if (err.status === 401 && localStorage.getItem('isLoggedin')) {
                    //   this.logout();
                    // }
                } catch (error) {
                    this.showErrorToast();
                }
            } else if (err && err.name === 'TimeoutError') {
                this.showErrorToast('', 'Timeout');
            } else {
                if (err.status === 404) {
                    this.showErrorToast();
                    return null;
                }

                if (typeof err === 'string') {
                    this.showErrorToast('', err);
                } else {
                    this.showErrorToast();
                }
            }
        } catch (error) {
            this.showErrorToast();
        }
    }

    public logout(isFromPlaylist = null) {
        const logoutTranslation = this.translate.instant('HOME.LOGOUT');
        const confirmationTranslation = this.translate.instant('HOME.LOGOUT_CONFIRMATION');
        const yes = this.translate.instant('HOME.YES')
        const no = this.translate.instant('HOME.NO')
        // this.messageService.confirm('LogOut!', 'Are you sure you want to Log Out?')
        this.messageService.confirm(logoutTranslation, confirmationTranslation)
            .subscribe((answer) => {
                if (answer === yes) {
                     this.openPlaylistLogoutModal();
                    // if (((this.getValueCookie(Constant.ISREMEMBER_FULLKEY))) || ((this.getValueCookie(Constant.ISREMEMBER_XKEY)))) {
                    // }
                    // else {
                    //     this.cookieService.removeAll();
                    // }
                    // this.logoutSubject.next();
                    
                    

                    // if (localStorage.getItem(Constant.FULLUSERID_KEY)) {
                    //     if (isFromPlaylist) {
                    //         this.router.navigate(['/add-playlist']);
                    //         localStorage.clear();
                    //         this.cleardb()


                    //     } else {
                    //         this.router.navigate(['/add-playlist']);
                    //         localStorage.clear();
                    //         this.cleardb()


                    //     }
                    // }
                    // if(localStorage.getItem(Constant.XCODE)) {
                    //     const codeData = {
                    //         code: localStorage.getItem('code'),
                    //         xtoken: localStorage.getItem(Constant.XTOKEN)
                    //     }
                    //     if(this.code === ''){
                    //         localStorage.clear();
                    //         localStorage.setItem('code', codeData.code);
                    //         localStorage.setItem(Constant.XTOKEN, codeData.xtoken);
                    //         this.router.navigate(['/server-login']);
                    //     }else if(this.code){
                    //         localStorage.clear();
                    //         localStorage.setItem('code', codeData.code);
                    //         localStorage.setItem(Constant.XTOKEN, codeData.xtoken);
                    //         this.router.navigate(['/code']);
                    //     }
                    //    }else if(localStorage.getItem(Constant.XSTREAMURL_KEY) && !this.code){
                    //     localStorage.clear();
                    //     this.clearCookieStorage();
                    //     this.router.navigate(['/add-playlist']);
                    //     this.cleardb()

                    //     }

                    // // xstram login with id, pass, url

                    // if (localStorage.getItem(Constant.XSTREAMURLs_KEY)) {
                    //     this.router.navigate(['/playlist']);
                    //     const codeData = {
                    //         code: localStorage.getItem('code'),
                    //         xtoken: localStorage.getItem(Constant.XTOKEN)
                    //     }
                    //     localStorage.clear();
                    //     localStorage.setItem('code', codeData.code);
                    //     localStorage.setItem(Constant.XTOKEN, codeData.xtoken);
                    //     this.cleardb()

                    // }
                    // if (localStorage.getItem(Constant.ONESTREAM)) {
                    //     this.router.navigate(['/OneStream-Login']);
                    //     localStorage.clear();
                    //     this.cleardb()

                    // }

                    // if (this.router.url.indexOf('playlist') > -1) {
                    //     this.router.navigate(['/add-playlist']);
                    //     localStorage.clear();
                    //     this.cleardb()
                    // }
                }
            });
    }

                openPlaylistLogoutModal() {
                this.bsModalRef = this.modalService.show(PlaylistlogoutModalComponent, {
                class: 'modal-md',
                initialState: {
                message: 'Do you want to keep your playlist after you logout of this account?',
                onClose: new Subject<string>()
                },
                ignoreBackdropClick: true,
                keyboard: false
            });

            this.bsModalRef.content.onClose.subscribe((result: string) => {
                if (result === 'yes') {
                    this.cleardb();
                    this.clearCookieStorage();
                    this.removeFullModeStorage();
                    // localStorage.removeItem('progressComplete');
                    localStorage.removeItem('mtoken')
                    localStorage.removeItem('userData')

                    const purple = JSON.parse(localStorage.getItem('purple_playlist') || '[]');
                    const xstreamLocal = JSON.parse(localStorage.getItem('xstream_playlists'));
                    const purpleLocal = purple.map((item: any) => ({ ...item, local: true }));
                    const mergeData = [...xstreamLocal,...purpleLocal];
                    localStorage.setItem('xstream_playlists', JSON.stringify(mergeData));
                    localStorage.setItem('purple_local', 'true');
                    localStorage.removeItem('Profile')
                    setTimeout(() => {
                    this.router.navigate(['/playlist']);
                        
                    }, 500);
                // this.clearAllPlaylists();
                } else {
                    this.cleardb();
                    this.clearCookieStorage();
                    this.removeFullModeStorage();
                    // localStorage.removeItem('progressComplete');
                    localStorage.removeItem('Profile')
                    localStorage.removeItem('mtoken')
                    localStorage.removeItem('userData')
                    localStorage.removeItem('purple_playlist')
                    setTimeout(() => {
                    window.location.reload();
                    this.router.navigate(['/playlist']);
                    }, 500);
                // User chose to keep playlists
                }
            });
            }

   

    

    async cleardb(){
        await db.categories.clear();
        await db.livetv.clear();
        await Moviesdb.categories.clear();
        await Moviesdb.movies.clear();
        await Seriesdb.series.clear();
        await Seriesdb.categories.clear();
        await localStorage.removeItem('progressComplete');

    }
    
    saveValueCookie(key: any, value: any) {
        try{
            const payload = JSON.parse(atob(value.split('.')[1]));
            const expiryInSeconds = payload.exp;
            // Convert expiry (in seconds) to JavaScript Date object
            const expiryDate = new Date(expiryInSeconds * 1000);
            this.cookieService.put(key, value,{expires:expiryDate});
        }catch{
            console.error('token not decode or invalid');
            
        }
    }
    saveValueUser(key:any,value:any){
        localStorage.setItem(key,value);
    }
    saveMediaToken(key:any,value:any){
        localStorage.setItem(key,value)
    }
    getValueCookie(key: any) {
        return this.cookieService.get(key);
    }
    clearCookieStorage() {
        this.cookieService.removeAll();
    }
    saveValueStorage(key: any, value: any) {
        localStorage.setItem(key, value);
    }
    getValueStorage(key: any) {
        return localStorage.getItem(key);
    }
    saveAPImethod(key:any,value:any){
        localStorage.setItem(key,value)
    }
    removeLocalStorage(key: any) {
        localStorage.removeItem(key);
    }
    removeXsreamStorage() {
        localStorage.removeItem(Constant.XSTREAMURL_KEY);
        localStorage.removeItem(Constant.XSTREAMUSERNAME_KEY);
        localStorage.removeItem(Constant.XSTREAMPASSWORD_KEY);
        localStorage.removeItem(Constant.XTOKEN);
    }
    removeFullModeStorage() {
        localStorage.removeItem(Constant.FULLURL_KEY);
        localStorage.removeItem(Constant.FULLUSERNAME_KEY);
        localStorage.removeItem(Constant.FULLPASSWORD_KEY);
        localStorage.removeItem(Constant.FULLUSERID_KEY);
    }
    clearData(){
        localStorage.removeItem(Constant.FULLURL_KEY);
        localStorage.removeItem(Constant.FULLUSERNAME_KEY);
        localStorage.removeItem(Constant.FULLPASSWORD_KEY);
        localStorage.removeItem(Constant.FULLUSERID_KEY);
    }
   async switchPlaylist(){
        await db.categories.clear();
        await db.livetv.clear();
        await Moviesdb.categories.clear();
        await Moviesdb.movies.clear();
        await Seriesdb.series.clear();
        await Seriesdb.categories.clear();
        localStorage.removeItem(Constant.FULLURL_KEY);
        localStorage.removeItem(Constant.FULLUSERNAME_KEY);
        localStorage.removeItem(Constant.FULLPASSWORD_KEY);
        localStorage.removeItem(Constant.FULLUSERID_KEY);
        localStorage.removeItem(Constant.APP_BACKGROUND);
        localStorage.removeItem(Constant.APP_LOGO);
        localStorage.removeItem(Constant.PLAYLIST_PROFILE);
        localStorage.removeItem('progressComplete');
        localStorage.removeItem('isLocalPlaylist');
        
    }
   async deleteAllDataByPlaylistId(playlist_id: number): Promise<void> {
  // 🎬 Movies
  const movieKeys = await Moviesdb.movies
    .where('playlist_id')
    .equals(playlist_id)
    .primaryKeys();
  await Moviesdb.movies.bulkDelete(movieKeys);

  const movieCategoryKeys = await Moviesdb.categories
    .where('playlist_id')
    .equals(playlist_id)
    .primaryKeys();
  await Moviesdb.categories.bulkDelete(movieCategoryKeys);

  const movieFavKeys = await Moviesdb.favorites
    .where('playlist_id')
    .equals(playlist_id)
    .primaryKeys();
  await Moviesdb.favorites.bulkDelete(movieFavKeys);

  // 📺 Series
  const seriesKeys = await Seriesdb.series
    .where('playlist_id')
    .equals(playlist_id)
    .primaryKeys();
  await Seriesdb.series.bulkDelete(seriesKeys);

  const seriesCategoryKeys = await Seriesdb.categories
    .where('playlist_id')
    .equals(playlist_id)
    .primaryKeys();
  await Seriesdb.categories.bulkDelete(seriesCategoryKeys);

  const seriesFavKeys = await Seriesdb.favorites
    .where('playlist_id')
    .equals(playlist_id)
    .primaryKeys();
  await Seriesdb.favorites.bulkDelete(seriesFavKeys);

  // 📡 LiveTV
  const livetvKeys = await db.livetv
    .where('playlist_id')
    .equals(playlist_id)
    .primaryKeys();
  await db.livetv.bulkDelete(livetvKeys);

  const livetvCategoryKeys = await db.categories
    .where('playlist_id')
    .equals(playlist_id)
    .primaryKeys();
  await db.categories.bulkDelete(livetvCategoryKeys);

  const livetvFavKeys = await db.favorites
    .where('playlist_id')
    .equals(playlist_id)
    .primaryKeys();
  await db.favorites.bulkDelete(livetvFavKeys);

  console.log(`✅ Deleted all data (movies, series, livetv, and favorites) for playlist_id: ${playlist_id}`);
}



    getFullUrl() {
        return localStorage.getItem(Constant.FULLURL_KEY);
    }
    getFullUsername() {
        return localStorage.getItem(Constant.FULLUSERNAME_KEY);
    }
    getFullPassword() {
        return localStorage.getItem(Constant.FULLPASSWORD_KEY);
    }
    getFullUserId() {
        return localStorage.getItem(Constant.USERDATA);
    }
    getXstreamUrl() {
        return localStorage.getItem(Constant.XSTREAMURL_KEY);
    }
    getXstreamUsername() {
        return localStorage.getItem(Constant.XSTREAMUSERNAME_KEY);
    }
    getXstreamPassword() {
        return localStorage.getItem(Constant.XSTREAMPASSWORD_KEY);
    }
    getOneStreamUrl(){
        return localStorage.getItem(Constant.ONEURL_KEY);
    }
    getOneStreamToken(){
        return localStorage.getItem(Constant.ONESTREAM);
    }
    // getXstreamUserId() {
    //     return localStorage.getItem(Constant.XSTREAMUSERID_KEY);
    // }
    deleteFavourit(key: any, item: any, callback) {
        const logoutTranslation = this.translate.instant('COMMON.REMOVE_FAV');
        const confirmationTranslation = this.translate.instant('COMMON.FAVOURITE_CONFIRMATION');
        const yes = this.translate.instant('HOME.YES')
        
        // const no = this.translate.instant('HOME.NO')
        this.messageService.confirm(logoutTranslation,confirmationTranslation )
        .subscribe((answer) => {
            if (answer === yes) {
                    let a = [];
                    let array: any;
                    let deledIndex: any;
                    let savedArray;
                    savedArray = JSON.parse(localStorage.getItem(key)) || [];
                    savedArray.map((ele: any, index) => {
                        if (ele.id == item.id) {
                            deledIndex = index;
                        }
                        else {
                            a.push(ele);
                        }
                    });
                    if (a.length > 0 || deledIndex == 0) {
                        localStorage.setItem(key, JSON.stringify(a));
                        callback(1);
                    }
                    else {
                        callback(0);
                    }

                }
            });
    }

    encrypt(value: string): string {
    return CryptoJS.AES.encrypt(value, this.secretKey).toString();
  }

  decrypt(encrypted: string): string {
    const bytes = CryptoJS.AES.decrypt(encrypted, this.secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  }

    send(channel: string,url: any) {
        console.log(channel,url);
        
        if (this.ipcRenderer) {
          this.ipcRenderer.send(channel, url);
        }else{
            window.open(`vlc://${url}`, "_blank");
        }

      }

      isLocalProfile(): boolean {
    const localProfileRaw = localStorage.getItem('localProfile') || '{}';
    try {
      const localProfile = JSON.parse(localProfileRaw);
      return localProfile?.local === true;
    } catch (e) {
      console.error('Invalid localProfile JSON:', e);
      return false;
    }
  }

    public preventSpace(event: any) {
        if ((event.charCode == 32 || event.charCode == 64) && !event.target.value) {
            event.preventDefault();
        }
    }

    public NumOnly(event: any) {
        let Numpattern = /^([0-9])*$/;
        let resultNum = Numpattern.test(event.key);
        return resultNum;

    }
}
